import { Injectable } from '@angular/core';
import { ApiResponse } from '@core/interface/api-response.interface';
import { PageableResponse } from '@core/interface/pageable.interface';
import { RefId } from '@core/interface/ref-id.interface';
import { FlowDefinitionService } from '@core/services/entities/flow-definition.service';
import {
  CreateFlowDefinitionRequestDto,
  ListFlowDefinitionRequestDto,
  UpdateFlowDefinitionRequestDto,
  UpdateFlowGroupsRequestDto,
  UpdateFlowStateRequestDto,
  UpdateFlowStepsRequestDto,
} from '@domain/flow-definition/dtos/flow-definition-request.dtos';
import { FlowDefinitionResponseDto } from '@domain/flow-definition/dtos/flow-definition-response.dto';
import { FlowDefinitionRepository } from '@domain/flow-definition/repositories/flow-definition.repository';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FlowDefinitionRepositoryService
  implements FlowDefinitionRepository
{
  constructor(private flowDefinitionService: FlowDefinitionService) {}

  list(
    request: ListFlowDefinitionRequestDto,
  ): Observable<ApiResponse<PageableResponse<FlowDefinitionResponseDto>>> {
    return this.flowDefinitionService.list(request);
  }

  show(request: RefId): Observable<ApiResponse<FlowDefinitionResponseDto>> {
    return this.flowDefinitionService.show(request);
  }

  create(
    request: CreateFlowDefinitionRequestDto,
  ): Observable<ApiResponse<FlowDefinitionResponseDto>> {
    return this.flowDefinitionService.create(request);
  }

  update(
    request: UpdateFlowDefinitionRequestDto,
  ): Observable<ApiResponse<FlowDefinitionResponseDto>> {
    return this.flowDefinitionService.update(request);
  }

  updateSteps(
    request: UpdateFlowStepsRequestDto,
  ): Observable<ApiResponse<FlowDefinitionResponseDto>> {
    return this.flowDefinitionService.updateSteps(request);
  }

  updateGroups(
    request: UpdateFlowGroupsRequestDto,
  ): Observable<ApiResponse<FlowDefinitionResponseDto>> {
    return this.flowDefinitionService.updateGroups(request);
  }

  publish(request: RefId): Observable<ApiResponse<FlowDefinitionResponseDto>> {
    return this.flowDefinitionService.publish(request);
  }

  updateState(
    request: UpdateFlowStateRequestDto,
  ): Observable<ApiResponse<FlowDefinitionResponseDto>> {
    return this.flowDefinitionService.updateState(request);
  }

  delete(request: RefId): Observable<ApiResponse<FlowDefinitionResponseDto>> {
    return this.flowDefinitionService.delete(request);
  }
}
